<div class="w-full px-6 py-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
  @for(video of videos; track video.link){
    <div class="group relative rounded-xl border border-gray-200 bg-card shadow-sm hover:shadow-lg transition overflow-hidden cursor-pointer"
         (click)="abrirTutorial(video.link)">
      <div class="aspect-video relative flex items-center justify-center"
           #box
           (click)="$event.stopPropagation(); verAqui(video.link)"
           [class]="'aspect-video relative flex items-center justify-center bg-gradient-to-br ' + gradientFrom + ' ' + gradientTo">
        <ng-container *ngIf="selectedVideoId !== extraerDriveId(video.link); else play">
          <mat-icon class="text-4xl text-indigo-600 transition-transform group-hover:scale-110">play_circle</mat-icon>
        </ng-container>
        <ng-template #play>
          <iframe class="absolute inset-0 w-full h-full" [src]="selectedVideoUrl" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </ng-template>
      </div>
      <div class="p-3">
        <div class="font-medium truncate" [matTooltip]="video.nombre">{{ video.nombre }}</div>
        <div class="mt-2 flex items-center gap-2 text-sm text-gray-500">
          <button mat-stroked-button color="primary" (click)="$event.stopPropagation(); abrirTutorial(video.link)">Abrir</button>
          <button mat-icon-button (click)="$event.stopPropagation(); copiarEnlace(video.link)" matTooltip="Copiar enlace">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>
      </div>
    </div>
  }
</div>

